module.exports = __webpack_public_path__ + "img/word.3cbb92e0.png";